<div class="min-h-screen bg-gray-100 flex items-center justify-center p-4">
  <div class="form-container w-full max-w-4xl">
    <h3 class="text-center">Crear usuario en bakna</h3>
    <div class="containerImg">
      <div class="imagen">
        <img
          src="../../../../assets/images/logoBankaSoloB.png"
          width="150px"
          alt=""
        />
      </div>
    </div>
    <p class="text-center">
      Completa la informacion requerida para procesar tu solicitud.
    </p>
    <div class="w-full max-w-6xl mx-auto bg-white">
      <form [formGroup]="userForm" class="py-6" (ngSubmit)="createUser()">
        <div class="grid grid-cols-1 md:grid-cols-3 gap-6">
          <!-- Nombre -->
          <div>
            <label
              for="name"
              class="block text-sm font-medium text-gray-700 mb-2"
            >
              Nombres
            </label>
            <input
              type="text"
              placeholder="Ingrese nombres"
              class="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-blue-500 focus:border-blue-500"
              formControlName="name"
              required
            />
            <div
              *ngIf="validacionInputReq('name')"
              style="display: block"
              class="invalid-feedback"
            >
              Por favor ingrese los nombres.
            </div>
          </div>

          <!-- Correo electrónico -->
          <div>
            <label class="block text-sm font-medium text-gray-700 mb-2">
              Correo electrónico
            </label>
            <input
              type="email"
              placeholder="Ingrese email"
              class="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-blue-500 focus:border-blue-500"
              formControlName="email"
              required
            />
            <div
              *ngIf="validacionInputReq('email')"
              style="display: block"
              class="invalid-feedback"
            >
              Ingrese una email valido.
            </div>
          </div>

          <!-- Password -->
          <div>
            <label class="block text-sm font-medium text-gray-700 mb-2">
              Contraseña
            </label>
            <input
              type="password"
              placeholder="Ingrese Contraseña"
              class="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-blue-500 focus:border-blue-500"
              formControlName="password"
              required
            />
            <div
              *ngIf="validacionInputReq('password')"
              style="display: block"
              class="invalid-feedback"
            >
              Ingrese una email valido.
            </div>
          </div>

          <!-- Confirmar Password -->
          <div>
            <label class="block text-sm font-medium text-gray-700 mb-2">
              Contraseña
            </label>
            <input
              type="password"
              placeholder="Ingrese Contraseña"
              class="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-blue-500 focus:border-blue-500"
              formControlName="passwordConfirmation"
              required
            />
            <div
              *ngIf="validacionInputReq('passwordConfirmation')"
              style="display: block"
              class="invalid-feedback"
            >
              Ingrese una email valido.
            </div>
          </div>

          <!-- Tipo de documento -->
          <div>
            <label class="block text-sm font-medium text-gray-700 mb-2">
              Tipo de documento
            </label>
            <select
              formControlName="documentType"
              class="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
              required
            >
              <option value="" selected disabled>Seleccione</option>
              <option value="CC">Cédula de ciudadanía</option>
              <option value="CE">Cédula de extranjeria</option>
              <option value="NIT">NIT</option>
            </select>
            <div
              *ngIf="validacionInputReq('documentType')"
              style="display: block"
              class="invalid-feedback"
            >
              Porfavor ingrese un tipo de documento.
            </div>
          </div>

          <!-- Número documento -->
          <div>
            <label class="block text-sm font-medium text-gray-700 mb-2">
              Número documento
            </label>
            <input
              formControlName="documentNumber"
              required
              type="text"
              placeholder="Ingrese documento"
              class="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-blue-500 focus:border-blue-500"
            />
            <div
              *ngIf="validacionInputReq('documentNumber')"
              style="display: block"
              class="invalid-feedback"
            >
              Porfavor ingrese un tipo de documento.
            </div>
          </div>

          <!-- Número de celular -->
          <div>
            <label class="block text-sm font-medium text-gray-700 mb-2">
              Número de celular
            </label>
            <input
              type="tel"
              placeholder="Ingrese celular"
              class="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-blue-500 focus:border-blue-500"
              formControlName="cellPhone"
              required
            />
            <div
              *ngIf="validacionInputReq('cellPhone')"
              style="display: block"
              class="invalid-feedback"
            >
              Porfavor ingrese un número de celular valido.
            </div>
          </div>

          <!-- Banco -->
          <div class="mb-3">
            <label for="bankId-input" class="form-label">Banco</label>
            <select
              class="form-select"
              placeholder="Seleccione una opcion"
              formControlName="bankId"
              required
            >
              <option value="" selected disabled>Seleccione</option>
              <option *ngFor="let bank of listBanks" [value]="bank.id">
                {{ bank.name }}
              </option>
            </select>
            <div
              *ngIf="validacionInputReq('bankId')"
              style="display: block"
              class="invalid-feedback"
            >
              Por favor seleccione un Banco.
            </div>
          </div>

          <!-- Tipo de cuenta -->
          <div class="mb-3 row">
            <label for="accountType-input" class="form-label">
              Tipo de cuenta
            </label>
            <div class="col-md-12">
              <select
                class="form-select"
                formControlName="accountType"
                required
              >
                <option value="" selected disabled>Seleccione</option>
                <option value="CH">Ahorros</option>
                <option value="CC">Corriente</option>
              </select>
            </div>
            <div
              *ngIf="validacionInputReq('accountType')"
              style="display: block"
              class="invalid-feedback"
            >
              Porfavor ingrese un tipo de cuenta.
            </div>
          </div>

          <!-- Numero de cuenta -->
          <div class="mb-3">
            <label for="accountNumber-input" class="form-label"
              >Numero de cuenta</label
            >
            <input
              type="text"
              id="accountNumber-input"
              class="form-control"
              placeholder="Ingrese el número de cuenta"
              formControlName="accountNumber"
              required
            />
            <div
              *ngIf="validacionInputReq('accountNumber')"
              style="display: block"
              class="invalid-feedback"
            >
              Porfavor ingrese el número de cuenta.
            </div>
          </div>

          <!-- Tipo de rol -->
          <div>
            <label class="block text-sm font-medium text-gray-700 mb-2">
              Rol de usuario
            </label>
            <select
              formControlName="userType"
              class="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
              required
            >
              <option value="" selected disabled>Seleccione</option>
              <option value="0">Cliente</option>
              <option value="1">Tienda</option>
              <option value="2">Inversionista</option>
            </select>
            <div
              *ngIf="validacionInputReq('userType')"
              style="display: block"
              class="invalid-feedback"
            >
              Porfavor ingrese un tipo de documento.
            </div>
          </div>

          <!-- Tipo de rol -->
          <div *ngIf="userForm.controls['userType'].value == 1">
            <label class="block text-sm font-medium text-gray-700 mb-2">
              ¿Fondea?
            </label>
            <select
              formControlName="funderStatus"
              class="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
            >
              <option value="" selected disabled>Seleccione</option>
              <option value="1">Si</option>
              <option value="0">No</option>
            </select>
            <div
              *ngIf="validacionInputReq('funderStatus')"
              style="display: block"
              class="invalid-feedback"
            >
              Porfavor ingrese un tipo de documento.
            </div>
          </div>

          <!-- Eres tienda? -->
          <div
            *ngIf="
              userForm.controls['userType'].value == 1 ||
              userForm.controls['userType'].value == 2
            "
          >
            <label class="block text-sm font-medium text-gray-700 mb-2">
              ¿Eres tienda?
            </label>
            <select
              formControlName="storeStatus"
              class="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
            >
              <option [ngValue]="true">Si</option>
              <option [ngValue]="false">No</option>
            </select>
          </div>
        </div>
        <div class="row">
          <button
            type="submit"
            [disabled]="!userForm.valid"
            class="w-25 px-6 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 disabled:opacity-50 disabled:cursor-not-allowed transition-colors duration-200"
          >
            Enviar
          </button>
        </div>
      </form>
      <!-- 
            <div class="prevs d-flex">
                <pre>{{ userForm.value | json }}</pre>
                <pre>{{ userForm.valid | json }}</pre>
            </div>
              -->
    </div>
  </div>
</div>
